import { useQuery } from 'react-query';

import { UASResult } from 'utils/UASTypes';

import { api } from '.';

import { Country } from 'typing/endpoints';

export const useCountries = () =>
	useQuery(
		'countries',
		() =>
			api({ skipToken: true })
				.get('countries', { searchParams: { pageSize: -1 } })
				.json<UASResult<Country>>(),
		{ staleTime: 3600000 },
	);
